import { render } from "./loyalty.vue?vue&type=template&id=8d40277e&scoped=true&ts=true"
import script from "./loyalty.vue?vue&type=script&lang=ts"
export * from "./loyalty.vue?vue&type=script&lang=ts"

import "./loyalty.vue?vue&type=style&index=0&id=8d40277e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d40277e"]])

export default __exports__